import TextTitleCondensed from 'components/TextTitleCondensed.js'
import React from 'react'

export default function TextTitleCompressedHeavyUpperCase (props) {
  return (
    <TextTitleCondensed
      fw='870'
      {...props}
    />
  )
}
